import { Constants } from '@pwc/pwc-deals-web-common';
import sessionStorage from 'common/helpers/sessionStorage';
import { isCustomColourConversionActive } from 'common/helpers/projectInitUtil';
import { CUSTOM_COLOR_CONVERSION_KEY } from 'common/constants/General';
import { clearSizingIfChartOnMobile } from '../../../common/helpers/junctionColorMapping';
import * as colourMaps from '../../../common/constants/PwcToJunctionStyles';

export const intersect = (a1, a2) =>
  a1 && a2 ? a1.filter((x) => a2.includes(x)) : [];

export const mapToJunctionStyles = (
  libraryItem,
  isSvg,
  isLiveReportPreview
) => {
  let mapped = isSvg ? libraryItem.renderedSvg : libraryItem.rendered;
  const contentColourConversion = sessionStorage.get(
    CUSTOM_COLOR_CONVERSION_KEY
  );
  const isCustomColourConversion = isCustomColourConversionActive(
    contentColourConversion
  );
  if (!mapped) {
    return '';
  }

  if (
    mapped &&
    !(
      libraryItem?.type ===
        Constants.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value ||
      libraryItem?.type === Constants.LIBRARY_ITEM_TYPES.EXCEL_CELL_RANGE.value
    )
  ) {
    const { rendered = {} } = libraryItem;
    const colourMap =
      rendered && rendered.indexOf('svg') > -1
        ? colourMaps.pwcToJunctionChartColours
        : colourMaps.pwcToJunctionTableColours;
    if (!isCustomColourConversion) {
      Object.keys(colourMap).forEach((sourceKey) => {
        const regex = new RegExp(`${sourceKey}`, 'mig');
        if (isLiveReportPreview) {
          mapped = mapped.replace(regex, sourceKey);
        } else {
          mapped = mapped.replace(regex, colourMap[sourceKey]);
        }
      });
    }
  }

  // it makes charts responsive
  mapped = clearSizingIfChartOnMobile(mapped);
  // Some hacks to get round Aspose's embedded MS derived styles
  const borderRightStringPattern = 'border-right:1px solid #000000';
  const borderRightRegex = new RegExp(`${borderRightStringPattern}`, 'mig');
  const borderRightReplacementString =
    'border-right:1px solid var(--table-border-color)';

  mapped = mapped.replace(borderRightRegex, borderRightReplacementString);

  const whiteBgStringPattern = 'background:#FFFFFF';
  const whiteBgRegex = new RegExp(`${whiteBgStringPattern}`, 'mig');
  mapped = mapped.replace(whiteBgRegex, '');
  mapped = mapped.replace(
    '<svg',
    '<svg style="max-width:100%;max-height:100%;" '
  );

  return mapped;
};

export const hasLibraryItemError = (item) =>
  Boolean(
    item.hasError ||
      (item.type !== Constants.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value &&
        item.error) ||
      (item.type === Constants.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value &&
        item.error?.isError) // PPT has different structure for error
  );
